import { IPoint2d } from '@/editor/math/IPoint2d';
import { selectedWall2dColor, wall2dColor } from '@/editor/constant/entity';
import WallModel from './2d/wallModel';
import BaseEntity from './BaseEntity';
import { EEntityType } from '../types';
import { WallData } from '../data/wall/Wall';
import { genPolygonHash } from '../utils/hash';

class WallEntity extends BaseEntity<EEntityType.Wall> {
  protected override _model2d: WallModel;
  private _outline: IPoint2d[] = [];

  private _hash: number = 0;
  private _sagitta: number = 0; // 弧墙更新判断时使用

  constructor(wallId: string) {
    super({ type: EEntityType.Wall, id: wallId });
    this._model2d = new WallModel(wallId, [this._outline]);
  }

  override set selected(value: boolean) {
    this._selected = value;
    this._model2d.setWallEntityColor(value ? selectedWall2dColor : wall2dColor);
  }

  override get selected() {
    return this._selected;
  }

  // 尽量通过模型管理器调用更新
  override update(wallData: WallData) {
    const newOutline = wallData.drawWallInfo.drawShape[0] || [];
    const newHash = genPolygonHash(newOutline);
    if (newHash === this._hash) return;

    this._hash = newHash;
    this._outline = newOutline;

    this._model2d.updateWallModel(this._id, [this._outline]);

    this._model2d.setWallEntityColor(this._selected ? selectedWall2dColor : wall2dColor);
  }

  set2DModelVisible(visible: boolean) {
    this._model2d.updateVisibleStatus(visible);
  }

  setVisible(visible: boolean) {
    this.set2DModelVisible(visible);
  }
}

export default WallEntity;
